import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import $ from 'jquery';
import 'datatables.net';
import ToastService from '../../services/ToastService';
import LeadsAssignedService from '../../services/LeadsAssignedService';
import RegisterUserService from '../../services/RegisterUserService';
import AuthService from '../../services/AuthService';
const API_URL = process.env.REACT_APP_API_URL;


function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function PendingFollowUps() {

const [pendingFollowups, setPendingFollowups] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);
const toast = useRef(null);
const toastService = new ToastService(toast);
const [selectedRows, setSelectedRows] = useState([]);
const [selectAll, setSelectAll] = useState(false);  
const navigate = useNavigate(); 
const [searchTerm] = useState('');
const tableRef = useRef(null);
const [employees, setselectedUser] =  useState([]);
const queryParam = useQuery();
const [UserId] = useState(queryParam.get("id") || AuthService.getCurrentUser().UserId);
const [LeadsAssigned, setLeadsAssigned] = useState([]);
const savedPageNumber = localStorage.getItem('currentPageNumber') ? parseInt(localStorage.getItem('currentPageNumber')) : 1;
const [pageNumber, setPageNumber] = useState(savedPageNumber); 
const pageSize = 10;
const ClientId = AuthService.getLoggedInClientId();
const [recordsTotal, setRecordsTotal] = useState(0);
const [recordsFiltered, setRecordsFiltered] = useState(0);

useEffect(() => {
  const token = AuthService.getToken(); 
 const table = $(tableRef.current).DataTable({
    processing: true,
    serverSide: true,
    displayStart: (savedPageNumber - 1) * pageSize,
    ajax: function (data, callback, settings) {
      const currentPage = Math.floor(data.start / data.length) + 1;
      localStorage.setItem("currentPageNumber", currentPage);
      setPageNumber(currentPage); // optional: in case you use it in UI
      const url = `${API_URL}/LeadAssigned/GetPendingFollowupList/${UserId}/${ClientId}/${currentPage}/${pageSize}`;
      $.ajax({
        url,
        type: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        success: function (response) {
          console.log("API Response:", response);

          callback({
            draw: data.draw,
            recordsTotal: response.value.recordsTotal,
            recordsFiltered: response.value.recordsFiltered,
            data: response.value.data.$values || [],
          });
        },
        error: function (xhr, error, code) {
          console.error("API Request failed:", error, xhr);
          toastService.showError("Error", "Failed to fetch leads data");
        },
      });
    },
    columnDefs: [
      { targets: [0], visible: true, searchable: false },
    ],
    columns: [
      { data: 'conversationComment', name: 'Conversation Comment', autoWidth: true },
      {
        data: null, 
        name: 'Lead Code', 
        render: function (data, type, row) {
          return `<span class="text-secondary text-xs font-weight-bold">${row.lead ? row.lead.leadCode : 'Unknown Lead'}</span>`;
        },
        autoWidth: true,
      },
      {
        data: null, 
        name: 'First Name',
        render: function (data, type, row) {
          return `<span class="text-secondary text-xs font-weight-bold">${row.lead ? row.lead.firstName : 'Unknown Lead'}</span>`;
        },
        autoWidth: true,
      },
      {
        data: null, 
        name: 'Contact Number',
        render: function (data, type, row) {
          return `<span class="text-secondary text-xs font-weight-bold">${row.lead ? row.lead.contactNumber : 'Unknown Lead'}</span>`;
        },
        autoWidth: true,
      },
      {
        data: null,
        name: "Source",
        render: function (data, type, row) {
          let iconHtml = "";
          const source = row.lead?.source?.toLowerCase() || "unknown";
      
          if (source === "fb") {
            iconHtml = `<i class="fab fa-facebook-square" style="color:#3b5998; font-size: 1.5rem;" title="Facebook"></i>`;
          } else if (source === "ig") {
            iconHtml = `<i class="fab fa-instagram" style="color:#C13584; font-size: 1.5rem;" title="Instagram"></i>`;
          } else {
            iconHtml = `<span class="text-muted">Unknown</span>`;
          }
      
          return `<span class="text-secondary text-xs font-weight-bold">${iconHtml}</span>`;
        },
        autoWidth: true,
      },
      {
        data: null, 
        name: 'Lead Status',
        render: function (data, type, row) {
          return `<span class="text-secondary text-xs font-weight-bold">${row.lead ? row.leadStatus.leadStatusName : 'Unknown Lead'}</span>`;
        },
        autoWidth: true,
      },
      {
        data: null, 
        name: 'Property',
        render: function (data, type, row) {
          return `<span class="text-secondary text-xs font-weight-bold">${row.lead ? row.lead.property : 'Unknown Lead'}</span>`;
        },
        autoWidth: true,
      },
      {
        data: 'leadAssignedDate',
        name: 'LeadAssigned Date',
        render: function (data) {
          debugger
          return new Date(data).toLocaleDateString(); 
        },
        autoWidth: true,
      },
      {
        data: null, 
        name: 'Employee Name',
        render: function (data, type, row) {
          return `<span class="text-secondary text-xs font-weight-bold">${row.user ? row.user.firstName + ' ' + row.user.lastName  : 'Unknown Lead'}</span>`;
        },
        autoWidth: true,
      },
      {
        data: 'followUpDate',
        name: 'followUpDate',
        render: function (data) {
          debugger
          return new Date(data).toLocaleDateString(); 
        },
        autoWidth: true,
      },
      {
        data: 'nextUpdate',
        name: 'Next Update',
        render: function (data) {
          debugger
          return new Date(data).toLocaleDateString(); 
        },
        autoWidth: true,
      },
      {
        data: null,
        render: function (data, type, row) {
          let actions = `
            <button class="btn btn-outline-dark btn-sm edit-lead-btn" data-id="${row.id}">
              <i class="pi pi-pencil" style="font-size: 1.5rem;"></i>
            </button>
          `;
          
          return actions;
        },
        orderable: false,  
        searchable: false, 
      }
    ],
    drawCallback: function (settings) {
    //   const currentPage = Math.floor(settings._iDisplayStart / settings._iDisplayLength) + 1;
    //   if (currentPage !== pageNumber) {
    //     setPageNumber(currentPage);  
    //     localStorage.setItem('currentPageNumber', currentPage);
    // } 
    },
    stateSave: true,
    // infoCallback: function (settings, start, end, max, total, pre) {
    //   const pageStart = start || 0;
    //    const pageEnd = end || 0;
    //   const pageInfo = `${pageStart} to ${pageEnd} of ${recordsFiltered} entries (Total: ${recordsTotal})`;
    //   return pageInfo;
    // },
  });
 
  $(tableRef.current).on('click', '.edit-lead-btn', function () {
    const leadId = $(this).data('id');
    navigate(`/editleadassigned/${leadId}`);
  });
 
return () => {
  if ($.fn.DataTable.isDataTable(tableRef.current)) {
    $(tableRef.current).DataTable().destroy();
  }
};
}, [UserId,ClientId]);


useEffect(() => {
    const fetchPendingFollowups = async () => {
    try {
        const userId= UserId;
        const data = await LeadsAssignedService.getPendingFollowups(userId,clientId);
        const clientId = AuthService.getLoggedInClientId();
        
            const sortedData = data.sort((a, b) => {
              const dateA = new Date(a.nextUpdate);
              const dateB = new Date(b.nextUpdate);
              return dateB - dateA;
          });

          setPendingFollowups(sortedData);
        } catch (error) {
        setError('Failed to fetch pending follow-ups');
        } finally {
        setLoading(false);
        }
    };

    const fetchEmployee = async()=> {
        try {
          const users = await RegisterUserService.getEmployessByRoleId(4);
          setselectedUser(users);
        } catch (error) { 
          console.error('Error fetching users:', error);  
          toastService.showError("Error", "Failed to fetch users data");
        }
      };

    fetchPendingFollowups();
    fetchEmployee();
    setTimeout(() => {
        $('#tableData').DataTable();
        }, 1000);
    }, [UserId]);


    useEffect(() => {
      if (Notification.permission === 'default') {
        Notification.requestPermission();
      }
    }, []);


    const sourceTypes = [
      { id: 1, name: "Facebook" },
      { id: 2, name: "Instagram" },
      { id: 3, name: "Reference" },
    ];
  
  
    const Role = {
      SUPERADMIN: { roleId: 1, roleName: 'SuperAdmin' },
      ADMIN: { roleId: 2, roleName: 'Admin' },
      MANAGER: { roleId: 3, roleName: 'Manager' },
      EMPLOYEE: { roleId: 4, roleName: 'Employee' },
    };
  
    const PropertyType= [
      { id: 1, name: "1BHK" },
      { id: 2, name: "2BHK" },
      { id: 3, name: "3BHK" },
      { id: 4, name: "4BHK" },
      { id: 5, name: "5BHK" },
      { id: 6, name: "Plot" },
      { id: 7, name: "Kothi" },
      { id: 8, name: "Other" },
    ];
  
    const LeadStatus= [
      { id: 1, name: "HotClient" },
      { id: 2, name: "Interested" },
      { id: 3, name: "NotInterested" },
      { id: 4, name: "PhoneNotPicked" },
      { id: 5, name: "InvalidNumber" },
      { id: 6, name: "ContactAfterSomeTime" },
      { id: 7, name: "CallBackLater" },
      { id: 8, name: "UpcomingVisit" },
      { id: 9, name: "Complete" },
      { id: 10, name: "Visited" },
    ];
  
   

    const filteredpendingFollowups = (pendingFollowups || []).filter((pendingfollowups) => {
      const leadStatus = LeadStatus.find((leadstatus) => leadstatus.id === pendingfollowups.leadStatusId);
      const leadStatusName = leadStatus ? leadStatus.name : "Unknown";
  
      if (leadStatusName === 'NotInterested' || leadStatusName === 'InvalidNumber') {
          return false; 
      }

      return (
        pendingfollowups.conversationComment &&
        pendingfollowups.conversationComment.toLowerCase().includes(searchTerm.toLowerCase())
      );
  });
  

  function getStatusClass(leadStatusName) {
    switch (leadStatusName) {
      case 'Interested':
        return 'badge badge-sm bg-gradient-success'; 
      case 'HotClient':
        return 'badge badge-sm bg-gradient-danger'; 
      case 'NotInterested':
        return 'badge badge-sm bg-gradient-secondary';   
      case 'CallBackLater':
        return 'badge badge-sm bg-gradient-dark'; 
      case 'InvalidNumber':
        return 'badge badge-sm bg-gradient-light';
      case 'Complete':
        return 'badge badge-sm bg-gradient-secondary';
      case 'Visited':
        return 'badge badge-sm bg-gradient-primary';
      case 'Upcoming Visit':
        return 'badge badge-sm bg-gradient-warning';
      default:
        return ''; 
    }
  }


  const renderPendingFollowups = () => {
    if (!Array.isArray(filteredpendingFollowups)) return null; 

    return filteredpendingFollowups.map((pending) => {

        const lead = pending.lead;

        const sourceType = lead ? sourceTypes.find((source) => source.id === lead.sourceTypeId) : null;
        const sourceTypeName = sourceType ? sourceType.name : "Unknown";
    
        const leadStatus = LeadStatus.find((leadstatus) => leadstatus.id === pending.leadStatusId);
        const leadStatusName = leadStatus ? leadStatus.name : "Unknown";
  
        const property = PropertyType.find((propertytype) => propertytype.id === pending.propertyTypeId);
        const propertyTypeName = property ? property.name : "Unknown";
  
        const employee = employees.find((emp) => emp.id === pending.userId);
        const employeeName = employee ? `${employee.firstName} ${employee.lastName}` : 'InActive Employee';
      return (
        <tr key={pending.id}>
        
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{pending.conversationComment}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{lead ? `${lead.leadCode}` : 'Unknown Lead'}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{lead ? `${lead.firstName}` : 'Unknown Lead'}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{lead ? `${lead.contactNumber}` : 'Unknown Lead'}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{lead ? `${lead.source}` : 'Unknown Lead'}</span>
        </td>
        <td class="align-middle text-center text-sm">
          <span  class={getStatusClass(leadStatusName)}> {leadStatusName}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{propertyTypeName}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{lead ? `${lead.property}` : 'Unknown Lead'}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold"> {new Date(pending.leadAssignedDate).toLocaleDateString()}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{employeeName}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">
              {new Date(pending.followUpDate).toLocaleString('en-US', {
                  hour: 'numeric',
                  minute: 'numeric',
                  second: 'numeric',
                  hour12: true,
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
              })}
            </span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">
                {new Date(pending.nextUpdate).toLocaleString('en-US', {
                 hour: 'numeric',
                 minute: 'numeric',
                 second: 'numeric',
                 hour12: true,
                 year: 'numeric',
                 month: 'long',
                 day: 'numeric'
             })}
            </span>
        </td>
        <td class="align-middle">
          <button
            className="btn btn-outline-dark btn-sm"
            onClick={() => navigate(`/editleadassigned/${pending.id}`)}
          >
            <i className="pi pi-pencil" style={{ fontSize: '1.5rem' }}></i>
          </button>
        </td>
      </tr>
      );
    });
  };
  return (
    <div>
      <Toast ref={toast} />
      <div className="p-2 m-2">
                      <div class="col-12">
                        <div class="card my-4">
                          <div class="card-body px-0 pb-2">
                            <div class="table-responsive p-0">
                            <table id="tableData" ref={tableRef} className="table display">
                                <thead>
                                  <tr>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Conversation Comments</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Lead Code</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Name</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Contact Number</th>
                                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Source</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Lead Status</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Property</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Lead Assigned Date</th>
                                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Employee</th>
                                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Follow Up</th>
                                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Next FollowUp</th>
                                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                              
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
    </div>
  );
}

export default PendingFollowUps;